/** @format — Document row/card actions dropdown */

import { ArrowUpRight, ExternalLink, MoreHorizontal } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import type { DocumentItem } from "../types";

export default function DocumentActionsMenu({
  document,
  onOpen,
  onGoToShipment,
  onOpenChange,
  triggerClassName,
  showGoToShipment = true,
}: {
  document: DocumentItem;
  onOpen: (doc: DocumentItem) => void;
  onGoToShipment: (doc: DocumentItem) => void;
  onOpenChange?: (open: boolean) => void;
  triggerClassName?: string;
  showGoToShipment?: boolean;
}) {
  return (
    <DropdownMenu onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Actions for ${document.name}`}
          className={cn(
            "flex h-6 w-6 shrink-0 items-center justify-center rounded bg-transparent text-[#0a0a0a] outline-none transition-colors hover:bg-neutral-100 focus:outline-none focus-visible:outline-none focus-visible:ring-0",
            triggerClassName,
          )}
          onClick={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
        >
          <MoreHorizontal className="h-4 w-4" strokeWidth={2} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={4}
        onCloseAutoFocus={(event) => event.preventDefault()}
        className="w-40 overflow-hidden rounded-lg border border-neutral-200 bg-white p-0.5 shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.1)]"
      >
        <DropdownMenuItem
          className="cursor-pointer gap-2 rounded-md px-2 py-[5.5px] text-sm text-[#0a0a0a] outline-none focus:bg-neutral-50 data-[highlighted]:bg-neutral-50"
          onSelect={(event) => {
            event.preventDefault();
            onOpen(document);
          }}
        >
          <ArrowUpRight className="h-4 w-4 text-neutral-500" strokeWidth={2} />
          Open
        </DropdownMenuItem>
        {showGoToShipment ? (
          <DropdownMenuItem
            className="cursor-pointer gap-2 rounded-md px-2 py-[5.5px] text-sm text-[#0a0a0a] outline-none focus:bg-neutral-50 data-[highlighted]:bg-neutral-50"
            onSelect={(event) => {
              event.preventDefault();
              onGoToShipment(document);
            }}
          >
            <ExternalLink className="h-4 w-4 text-neutral-600" strokeWidth={2} />
            Go to shipment
          </DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
